import { Injectable } from '@angular/core';
import Holidays from 'date-holidays';

@Injectable({
  providedIn: 'root'
})
export class ScheduleCalculationService {

  constructor() { }

  dayOfWeekStr = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
  ];

  CURRENT_MONTH = 1;
  NEXT_MONTH = 2;
  THE_MONTH_AFTER_NEXT = 3;

  isHoliday(date: Date) {
    const dayOfNum = date.getDay();
    const dayOfStr = this.dayOfWeekStr[dayOfNum];
    if (dayOfStr === "saturday" || dayOfStr === "sunday") return true;
  }

  isJapaneseHoliday(date: Date | string) {
    const hd = new Holidays();
    hd.getCountries('JP');
    hd.init('JP');
    return hd.isHoliday(new Date(date));
  }

  calcThreeBusinessdaysAgoFromEndOfTargetMonth(date: Date | string, targetMonth: number) {
    const targetDate = new Date(date);
    const endOfMonthDate = new Date(targetDate.getFullYear(), targetDate.getMonth() + targetMonth, 0);
    let minus_date = endOfMonthDate;
    const minus_businessdays = 3;
    let count = 0;
    while (count < minus_businessdays) {
      if (!this.isHoliday(minus_date) && !this.isJapaneseHoliday(minus_date)) {
        count++;
        //ループの最後の１回は対象日のチェックなのでマイナスしない
        if (count < minus_businessdays) {
          minus_date.setDate(minus_date.getDate() - 1);
        }
      } else {
        //土日祝日の場合はcountを増やさない。
        minus_date.setDate(minus_date.getDate() - 1);
      }
    }
    return minus_date;
  }

  checkBusinessdayEndOfTargetMonth(date: Date | string | undefined, targetMonth: number) {
    if (!date) {
      return;
    }
    const targetDate = new Date(date);
    const endOfMonthDate = new Date(targetDate.getFullYear(), targetDate.getMonth() + targetMonth, 0);
    let plus_date = endOfMonthDate;
    const plus_businessdays = 1;
    let count = 0;
    while (count < plus_businessdays) {
      if (!this.isHoliday(plus_date)) {
        count++;
        //ループの最後の１回は対象日のチェックなのでプラスしない
        if (count < plus_businessdays) {
          plus_date.setDate(plus_date.getDate() + 1);
        }
      } else if (this.isHoliday(plus_date)) {
        plus_date.setDate(plus_date.getDate() + 1);
      }
    }
    return plus_date;
  }

  calcScheduledDateOfPayment(date: Date | string | undefined | null) {
    if (!date) {
      return;
    }
    const dateOfDeliverly = new Date(date);
    const lastRequestDay = this.calcThreeBusinessdaysAgoFromEndOfTargetMonth(dateOfDeliverly, this.CURRENT_MONTH);
    if (dateOfDeliverly.getDate() <= lastRequestDay.getDate()) {
      return this.checkBusinessdayEndOfTargetMonth(dateOfDeliverly, this.NEXT_MONTH);
    } else {
      return this.checkBusinessdayEndOfTargetMonth(dateOfDeliverly, this.THE_MONTH_AFTER_NEXT);
    }
  }

  calcScheduledDateOfInvoice(date: Date | string | undefined | null) {
    if (!date) {
      return;
    }
    const dateOfDeliverly = new Date(date);
    const lastRequestDay = this.calcThreeBusinessdaysAgoFromEndOfTargetMonth(dateOfDeliverly, this.CURRENT_MONTH);
    if (dateOfDeliverly <= lastRequestDay) {
      return lastRequestDay;
    } else {
      return this.calcThreeBusinessdaysAgoFromEndOfTargetMonth(dateOfDeliverly, this.NEXT_MONTH);
    }
  }
}
